import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import pandaImg from '../../../assets/images/panda.png'
import AuditDetailsForm from '../ModalComponents/AuditDetails/AuditDetails'
import GroupDetailsForm from '../ModalComponents/GroupDetails/GroupDetails'
import AssignAuditForm from '../ModalComponents/AssignAudit/AssignAudit'
import CreateAuditSummary from '../ModalComponents/AuditSummary/summary'
import ScheduleAudit from '../ModalComponents/ScheduleAudit'
import {AuditModalBarContext} from '../../../context/AuditModalBar'
import {AuditPaneContext} from '../../../context/AuditPane'
import {AuditDetailsContext} from '../../../context/Modal/AuditDetails'

function Body({error}) {
  const totalCreateForms = 4
  const modalBar = React.useContext(AuditModalBarContext)
  const paneState = React.useContext(AuditPaneContext)
  const formState = modalBar.formState
  const activeCreateForm = modalBar.activeCreateForm
  const [errror, setErrror] = useState()

  const {name: auditName} = React.useContext(AuditDetailsContext)

  useEffect(() => {
    setErrror(error)
  }, [error])

  const validateName = input => {
    if (activeCreateForm === 0 && input.includes('/')) {
      setErrror('Special character forward slash (/) is not allowed. Please remove to proceed.')
      return false
    } else {
      setErrror('')
      return true
    }
  }

  const prevButton = () => (
    <span
      onClick={() => (formState ? modalBar.handleStatusforPreviousNextButton(-1) : null)}
      style={activeCreateForm !== 0 ? {display: 'block'} : {display: 'none'}}
    >
      <button
        type="button"
        id={
          activeCreateForm === 1
            ? 'btn-prev-0'
            : activeCreateForm === 2
            ? 'btn-prev-1'
            : activeCreateForm === 3
            ? 'btn-prev-2'
            : 'btn-prev-0'
        }
        className="btn btn-circle btn-xl"
      >
        <ChevronLeftIcon />
      </button>
    </span>
  )

  const nextButton = () => {
    return (
      <span
        onClick={() => {
          const isValid = validateName(auditName)

          if (formState && isValid) {
            modalBar.handleStatusforPreviousNextButton(1)
          }
        }}
      >
        <button
          type="button"
          id={
            activeCreateForm === 0
              ? 'btn-next-1'
              : activeCreateForm === 1
              ? 'btn-next-2'
              : activeCreateForm === 2
              ? 'btn-next-3'
              : 'btn-next-1'
          }
          className="btn btn-circle btn-xl"
          disabled={modalBar.isNameLoading || !formState}
        >
          <ChevronRightIcon />
        </button>
      </span>
    )
  }

  const currentModalScreen = () => {
    switch (activeCreateForm) {
      case 0:
        return <AuditDetailsForm error={errror} setError={setErrror} />
      case 1:
        return <GroupDetailsForm />
      case 2:
        return <AssignAuditForm />
      case 3:
        return <CreateAuditSummary />
      default:
        return null
    }
  }

  return (
    <Modal.Body>
      {paneState.modalType === 'Schedule' ? (
        <div>
          <div className="row">
            <ScheduleAudit />
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-1" id="btn1">
            {' '}
            {prevButton()}{' '}
          </div>
          <div className="col-10">{currentModalScreen()}</div>
          <div className="col-1" id="btn1">
            {nextButton()}
          </div>
          <img src={pandaImg} className="panda-image" alt="img"></img>
        </div>
      )}
    </Modal.Body>
  )
}

export default Body
